module.exports = __webpack_public_path__ + "static/media/IC213Renew.fbc6344d.jpg";